import dayjs from 'dayjs'
import { globalVariable } from './exportVariable'

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)

export function jsontoString(options) {
  return Object.keys(options).reduce((prev, curv, index, arr) => {
    return (
      prev + curv + '=' + options[curv] + (index === arr.length - 1 ? '' : '&')
    )
  }, '')
}

export function stringToJson(str) {
  if (isJsonString(str)) {
    try {
      return JSON.parse(str)
    } catch (e) {
      window.console.log(e)
    }
  }
  return str
}

// 获取cookies
export function getCookie(name) {
  let cookie = process.server
    ? globalVariable?.context?.req?.headers?.cookie || ''
    : document.cookie
  let cookieMap = cookie.split('; ')
  for (var i = 0; i < cookieMap.length; i++) {
    let arr = cookieMap[i].split('=')
    if (name == arr[0]) {
      return arr[1]
    }
  }
  return ''
}

export function isObj(value) {
  return value && Object.prototype.toString.call(value) === '[object Object]'
}

export function isString(value) {
  return value && Object.prototype.toString.call(value) === '[object String]'
}

export function isArray(value) {
  return value && Object.prototype.toString.call(value) === '[object Array]'
}

export function isNumber(value) {
  if (value === null) return false
  const toNumber = +value
  return isNaN(toNumber) ? false : typeof toNumber === 'number'
}

export function isJsonString(str) {
  if (isString(str)) {
    try {
      str = JSON.parse(str)
      if (isObj(str) || isArray(str)) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

export function emailValidator(val) {
  return /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)$/.test(
    val
  )
}
/**
 * 限制数组中每一项字符串的长度，若一行数据过长，则按照限制长度分割为几行，可用于轮播数组
 * @param {Array} strArr : 字符串数组
 * @param {Number} limitCount : 字符串的限制长度
 * @returns 限制长度内的字符串数组
 */
export function getLimitedStrList(strArr, limitCount) {
  let res = []
  strArr.forEach((str) => {
    if (str.length > limitCount) {
      const num = Math.ceil(str.length / limitCount)
      for (let i = 0; i < num; i++) {
        if (i < num - 1) {
          res.push(str.slice(i * limitCount, (i + 1) * limitCount))
        } else {
          res.push(str.slice(i * limitCount))
        }
      }
    } else {
      res.push(str)
    }
  })
  return res
}

export function checkIsColor(bgVal) {
  let val = bgVal.trim()
  if (val.slice(-1) === ';') {
    // 防止后台输入的色值带上了分号
    val = val.slice(0, -1)
  }
  let type = ''
  if (/^rgb\(/.test(val)) {
    //如果是rgb开头，200-249，250-255，0-199
    type =
      '^[rR][gG][Bb][(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){2}[\\s]*(2[0-4]\\d|25[0-5]|[01]?\\d\\d?)[\\s]*[)]{1}$'
  } else if (/^rgba\(/.test(val)) {
    //如果是rgba开头，判断0-255:200-249，250-255，0-199 判断0-1：0 1 1.0 0.0-0.9
    type =
      '^[rR][gG][Bb][Aa][(]([\\s]*(2[0-4][0-9]|25[0-5]|[01]?[0-9][0-9]?)[\\s]*,){3}[\\s]*(1|1.0|0|0.[0-9])[\\s]*[)]{1}$'
  } else if (/^#/.test(val)) {
    //六位或者三位
    type = '^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$'
  } else if (/^hsl\(/.test(val)) {
    //判断0-360 判断0-100%(0可以没有百分号)
    type =
      '^[hH][Ss][Ll][(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*)[)]$'
  } else if (/^hsla\(/.test(val)) {
    type =
      '^[hH][Ss][Ll][Aa][(]([\\s]*(2[0-9][0-9]|360｜3[0-5][0-9]|[01]?[0-9][0-9]?)[\\s]*,)([\\s]*((100|[0-9][0-9]?)%|0)[\\s]*,){2}([\\s]*(1|1.0|0|0.[0-9])[\\s]*)[)]$'
  } else if (/^linear-gradient\(.*\)$/.test(val)) {
    // 并未严格检查渐变色格式
    type = /^linear-gradient\(.*\)$/
  }
  let reg = new RegExp(type)
  return type && reg.test(val)
}
